import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20artistic%20abstract%20background%20with%20flowing%20golden%20and%20crimson%20gradients%20reminiscent%20of%20ancient%20Chinese%20silk%20scrolls%2C%20soft%20ethereal%20light%20beams%2C%20delicate%20floating%20particles%20like%20fireflies%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20dreamy%20atmospheric%20feel%2C%20clean%20abstract%20textures%20without%20any%20text%20or%20people&width=1920&height=1080&seq=hero-bg-po18&orientation=landscape"
          alt="po18官网app - 海量小说阅读平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight">
          海量小说
          <span className="block text-primary-400">尽在掌中</span>
        </h1>
        <p className="mt-6 text-base md:text-lg text-background-200 max-w-2xl mx-auto leading-relaxed">
          {siteConfig.description}覆盖玄幻、言情、都市、科幻等数十种热门分类，每日更新海量内容，随时随地畅享阅读。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-10">
          <Link
            to="/about"
            className="whitespace-nowrap cursor-pointer bg-primary-500 text-background-50 px-8 py-3.5 rounded-full text-base font-medium hover:bg-primary-600 transition-all duration-300 transform hover:scale-105"
          >
            <i className="ri-download-cloud-line mr-2"></i>
            立即下载 App
          </Link>
          <Link
            to="/article/guide-1"
            className="whitespace-nowrap cursor-pointer border border-background-200/50 text-background-100 px-8 py-3.5 rounded-full text-base font-medium hover:bg-background-50/10 transition-all duration-300"
          >
            <i className="ri-book-read-line mr-2"></i>
            查看使用指南
          </Link>
        </div>
        <div className="flex items-center justify-center gap-8 mt-12 text-background-300 text-sm">
          <div className="flex items-center gap-2">
            <i className="ri-shield-check-line text-lg text-accent-400"></i>
            <span>官方正版</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-smartphone-line text-lg text-accent-400"></i>
            <span>安卓/iOS</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-user-heart-line text-lg text-accent-400"></i>
            <span>5000万+用户</span>
          </div>
        </div>
      </div>
    </section>
  );
}